<template>
  <page-banner
    dense
    color="orange-1"
    :shadow="1"
  >
    <q-item-label
      v-if="existing"
      class="text-bold q-py-xs"
    >
      You cannot use a previous password
    </q-item-label>

    <q-list>
      <q-item-wrapper
        class="invisible-item q-px-none"
        icon="mdi-check"
        caption="Minimum 8 characters"
        :caption-class="{'text-bold': true, 'text-green-7': reqMinimumChars}"
        :color="reqMinimumChars ? 'green-6' : undefined"
        :icon-class="{'opaque-40': !reqMinimumChars}"
      />
      <q-item-wrapper
        class="invisible-item q-px-none"
        icon="mdi-check"
        caption="Contain at least one lowercase letter"
        :caption-class="{'text-bold': true, 'text-green-7': reqLowercaseChars}"
        :color="reqLowercaseChars ? 'green-6' : undefined"
        :icon-class="{'opaque-40': !reqLowercaseChars}"
      />
      <q-item-wrapper
        class="invisible-item q-px-none"
        icon="mdi-check"
        caption="Contain at least one uppercase letter"
        :caption-class="{'text-bold': true, 'text-green-7': reqUppercaseChars}"
        :color="reqUppercaseChars ? 'green-6' : undefined"
        :icon-class="{'opaque-40': !reqUppercaseChars}"
      />
      <q-item-wrapper
        class="invisible-item q-px-none"
        icon="mdi-check"
        caption="Contain a special character (!@#$%^&*)"
        :caption-class="{'text-bold': true, 'text-green-7': reqSpecialChars}"
        :color="reqSpecialChars ? 'green-6' : undefined"
        :icon-class="{'opaque-40': !reqSpecialChars}"
      />
    </q-list>
  </page-banner>
</template>

<script>
// Partial containing password requirements
export default {
  props: {
    password: {
      type: String,
      default: null
    },
    existing: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    reqMinimumChars () {
      return (this.password || '').length >= 8
    },
    reqUppercaseChars () {
      return /[A-Z]/.test(this.password || '')
    },
    reqLowercaseChars () {
      return /[a-z]/.test(this.password || '')
    },
    reqSpecialChars () {
      return /[!@#$%^&*]/.test(this.password || '')
    }
  }
}
</script>
